var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftMouseFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.522,
    height: 48.259,
    viewBox: "0 0 29.522 48.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g7438",
    transform: "translate(554.299 -419.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7445",
    transform: "translate(-554.039 419.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5367",
    d: "M29.942,1465.2c-.218,0-.485.245-.87.807-.823,1.287-8.591,7.342-15.179,0-2.118-2.328-.941,3.85-6.236,7.454.941,10.263,7.412,13.878,14.47,14.583,6.941.694,15.295-7.587,14.471-14.93-5.748-2.41-5.607-7.945-6.657-7.914Zm-7.695,9.313c4.471-.113,4.469,6.883-.12,6.883S17.777,1474.512,22.248,1474.512Z",
    transform: "translate(-7.655 -1440.083)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5369",
    d: "M7.634,1217.563c3.177-2.8,2.706-2.563,4.588-6.995,1.529-3.615,1.882,3.38,9.06,3.268,7.176,0,8.117-6.882,9.529-3.615,1.412,3.38,1.412,4.779,5.764,7.107.236-4.085-3.294-9.211-2-19.7.706-5.249-1.529-10.492-2.706-10.842.117,3.614.354,4.43.236,8.861-.119,4.544-3.765,14.807-10.471,14.807s-10.353-10.028-10.118-14.807c.118-4.781-.353-3.033.588-8.628-2.235,1.865-2.824,8.393-2.588,10.262,1.059,8.394-2,16.43-1.882,20.28",
    transform: "translate(-7.631 -1184.416)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5371",
    d: "M68.3,1158.105c-.591-.116-6.38.35-9.1,2.682-2.126,10.492,1.873,22.859,9.434,22.859,7.561-.112,11-12.6,9.822-23.326a16.431,16.431,0,0,0-9.569-2.215,26.933,26.933,0,0,0-.119,4.081s1.891.349,1.891,1.049v5.594c0,1.522-2.025,1.634-2.025,1.634s.344,11.281,0,13.184c.026-.045-.366-3.114-.391-5.739v-7.446s-1.955-.235-2.073-1.051a30.648,30.648,0,0,1,0-5.709,1.92,1.92,0,0,1,2.127-1.516c.118-1.4-.236-3.031,0-4.081",
    transform: "translate(-54.417 -1158.066)",
    fill: "#ffc627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5373",
    d: "M152.927,1212.967a40.374,40.374,0,0,0-.116,4.782c.116,2.093,3.5,1.512,3.613.112v-5.011c0-1.749-3.38-1.866-3.5.116",
    transform: "translate(-140.673 -1207.098)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5375",
    d: "M148.188,1582.268c4.257,0,3.861,6.239-.1,6.239-4.06,0-4.159-6.239.1-6.239",
    transform: "translate(-133.548 -1547.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5371-2",
    "data-name": "path5371",
    d: "M67.456,1183.647c7.526-.112,10.954-12.6,9.777-23.326a16.292,16.292,0,0,0-9.525-2.215,27.058,27.058,0,0,0-.118,4.081s1.882.349,1.882,1.049v5.594c0,1.522-2.016,1.634-2.016,1.634s.343,11.281,0,13.184",
    transform: "translate(-53.181 -1158.067)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMouseFr);
export default __webpack_public_path__ + "static/media/left-mouse-fr.57c67ece4c07324c8183417c83cb1030.svg";
export { ForwardRef as ReactComponent };